import React, {useState} from "react"

import adminTracking from "@irati-tracking/admin"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {H3, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Close from "@irati/ui/src/Close"
import theme from "@irati/ui/src/global/theme"

import {SETTINGS_LOGIN_INTEGRATION_DSYNC} from "../../routes/routeConfig"
import {Banner} from "../UnusedLicensesBanner/styled"
import dsyncIntegration from "../../images/dsync_integration.svg"

interface Props {
  onCallback: () => void
}

const DsyncIntegrationBanner: React.FC<Props> = ({onCallback}) => {
  const [show, setShow] = useState<boolean>(true)

  const handleClose = () => {
    setShow(false)
    onCallback()
  }

  const handleButton = () => {
    adminTracking.navigationClickDsyncIntegrationPage()
  }

  return (
    show && (
      <Banner>
        <Close top={theme.spacing.two} right={theme.spacing.two} onClick={handleClose} />
        <Flex justifyContent="space-between" width="100%">
          <Flex gap={theme.spacing.three}>
            <img src={dsyncIntegration} alt="dsyncIntegration" />
            <Flex direction="column" justifyContent="center" gap={theme.spacing.one}>
              <H3>
                <FormattedMessage id="admin.manageUsers.dsyncIntegration.title" />
              </H3>
              <Body>
                <FormattedMessage id="admin.manageUsers.dsyncIntegration.subTitle" />
              </Body>
            </Flex>
          </Flex>
          <Flex alignItems="center" gap={theme.spacing.one}>
            <ButtonRouterLink primary to={SETTINGS_LOGIN_INTEGRATION_DSYNC} onClick={handleButton}>
              <FormattedMessage id="admin.manageUsers.dsyncIntegration.button.addUsers" />
            </ButtonRouterLink>
            <Button onClick={handleClose}>
              <FormattedMessage id="admin.manageUsers.dsyncIntegration.button.notNow" />
            </Button>
          </Flex>
        </Flex>
      </Banner>
    )
  )
}

export default DsyncIntegrationBanner
